define.alias("shared/components/shared/link", "calendar/components/shared/link");